import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { isImmutable } from '../../helpers/Immutable';
import t from '../../lib/I18n';

import FormField from './Field';
import FormError from './Error';

class ValidatedFormField extends React.PureComponent {

    static propTypes = {
        outsideLabel: PropTypes.bool,
        visited: PropTypes.bool,
        validation: PropTypes.object,
        error: PropTypes.string,
        errorClassName: PropTypes.string,
        hideError: PropTypes.bool,
        avoidPaste: PropTypes.bool,
        ...FormField.propTypes
    };

    static defaultProps = Object.assign({}, FormField.defaultProps);

    state = {
        visited: !!this.props.form[this.props.field] || this.props.visited
    };

    componentDidMount () {
        this._isMounted = true;
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        if ('visited' in nextProps && !this.state.visited) {
            this.setState({ visited: nextProps.visited });
        }
        if (nextProps.resetVisited && this.state.visited) {
            this.setState({ visited: false });
        }
    }

    _makeHandleBlur = ({ onBlur }) => (field, value) => {
        /**
         *  We don't want this to run right away, as it would show
         *  Errors for the previous form state.
         *  Its hacky, but it works until we have a better way
         *  NOTE: "isMounted()" is not allowed with plain ES6 classes
         */
        _.delay(() => {
            if (this._isMounted) {
                this.setState({ visited: true });
                onBlur(field, value, this._resetVisited);
            }
        }, 350);
    };

    _getError ({ validation, form, field, error }) {
        if (error) {
            return error;
        } else if (validation) {
            return isImmutable(validation) ? validation.get(field) : validation[field];
        }
        return form.getError(field);
    }

    _resetVisited = () => {
        this.setState({ visited: false });
    }

    render () {
        const { className, type, required, focusForAmend, label, outsideLabel, hideError, speakDigits } = this.props;
        const errorMessage = this._getError(this.props);
        const showInvalid = this.state.visited && errorMessage;
        const newProps = _.omit(this.props, ['visited']);

        if (showInvalid) {
            newProps.label = label
                ? (<span aria-live="polite">{ label }
                        <span className={ classnames({ "sr-only": ['checkbox', 'radio'].includes(type) }) }>
                            { t('error.title') }: { errorMessage}.
                        </span>
                    </span>)
                : <span aria-live="polite">{ t('error.title') }: { errorMessage }.</span>;
            newProps.labelText = label;
        }

        const classNames = classnames({
            'input--valid': !showInvalid && type !== 'checkbox',
            'input--invalid': showInvalid && type !== 'checkbox',
            'input--amend': focusForAmend && type === 'select',
            'input--outside-label': outsideLabel,
            'speak-digits': speakDigits,
        }, className);

        // Checkbox form fields require the validation state classes to
        // be at a higher level than that of normal text based form fields
        const checkboxClassNames = classnames('validated-form-field', {
            'checkbox--required': required && type === 'checkbox',
            'checkbox--valid': !showInvalid && type === 'checkbox',
            'checkbox--invalid': showInvalid && type === 'checkbox',
            'validated-field--required': required,
            'validated-field--valid': !showInvalid,
            'validated-field--invalid': showInvalid,
        });


        const errorId = `form-error-${type}-${this.props.name}`;
        return (
            <div className={checkboxClassNames}>
                <FormField
                    {...newProps}
                    className={classNames}
                    onBlur={this._makeHandleBlur(this.props)}
                    onFocus={this.props.onFocus}
                    aria-invalid={Boolean(showInvalid)}
                    {...(showInvalid && !hideError && {
                        'aria-describedby': this.props['aria-describedby'] || errorId
                    })}
                />

                {showInvalid && !hideError && (
                    <FormError
                        id={errorId}
                        message={errorMessage}
                        className={classnames(this.props.errorClassName, {
                            'alert--outside-label': outsideLabel,
                        })}
                    />
                )}
            </div>
        );
    }

}


export default ValidatedFormField;



// WEBPACK FOOTER //
// ./src/components/form/ValidatedField.js